module.exports = function createDataUri(mimeType, base64String) { //TODO
    return `data:${mimeType};base64,${base64String}`;
}
